"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AboutLinda() {
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    rootMargin: "0px 0px -50px 0px"
  });
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    rootMargin: "0px 0px -50px 0px"
  });
  return <section>
      <div ref={imageRef} className={isImageVisible ? "visible" : "hidden"}>
        {/* Image content */}
      </div>
      <div ref={contentRef} className={isContentVisible ? "visible" : "hidden"}>
        {/* Content */}
      </div>
    </section>;
}